import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OrdersHistorys } from "../../../../Constant";
import DataTable from "react-data-table-component";
import { ORDER_HISTORY_DATA, ORDER_HISTORY_DATA_COLUMN } from "../../../../Data/Ecommerce";

const DtataTableOrderHistory = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={OrdersHistorys} />
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable data={ORDER_HISTORY_DATA} columns={ORDER_HISTORY_DATA_COLUMN} className="table-bordernone display" highlightOnHover noHeader pagination paginationServer />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DtataTableOrderHistory;
